import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from '@guryou/hooks';
import { Block, DefaultText, FullScreenSpinner, MediumText, SmallGrayText } from '@guryou/html-components';
import { StateStatus, updateUserLogin } from '@guryou/redux';
import ServiceBlock from 'onboard/components/ServiceBlock';
import SkipBlock from 'onboard/components/SkipBlock';
import FormContainer from 'onboard/containers/FormContainer';
import InfoContainer from 'onboard/containers/InfoContainer';
import PlayGuideVideoEmbed from 'onboard/containers/PlayGuideVideoEmbed';
import TitleContainer from 'onboard/containers/TitleContainer';
import { useOnboardContext } from 'onboard/context';
import { guideVideos } from 'onboard/GuideVideosUrls';
import { persistor } from 'store';
import { dealTokens } from 'components/shared';

import CheckboxInfoContainer from '../containers/CheckboxInfoContainer';
import MainContainer from '../containers/MainContainer';

const SelectService = () => {
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();

  const { setActiveStep, finished, createdProviderId } = useOnboardContext();

  useEffectOnce(() => {
    if (+auth.data.providerId !== +createdProviderId) {
      dispatch(updateUserLogin(+auth.data.userId, +createdProviderId, persistor));
    }
  });

  if (auth.status === StateStatus.REFRESHING) {
    return <FullScreenSpinner />;
  }

  return (
    <MainContainer>
      <FormContainer>
        <TitleContainer title={t('ONBOARD.centerServicesTitle')} subTitle={t('ONBOARD.centerServicesSubtitle')} />
        <Block lg={10} md={12} xs={12} margin={0} marginTop={6}>
          <ServiceBlock title={t('ONBOARD.services')} setActiveStep={setActiveStep} finished={finished} type="service" />
          <ServiceBlock title={t('ONBOARD.courses')} setActiveStep={setActiveStep} finished={finished} type="course" />
          <ServiceBlock title={t('ONBOARD.events')} setActiveStep={setActiveStep} finished={finished} type="event" />
          <SmallGrayText>{t('ONBOARD.dontWorry')}</SmallGrayText>
          <ServiceBlock title={`${t('ONBOARD.trainingPlans')} & ${t('ONBOARD.videos')}`} disabled={true} />
          <ServiceBlock title={t('MEMBERSHIPS.titlePlural')} disabled={true} />
          <SkipBlock title={t('ONBOARD.skipStepsToProvider')} />
        </Block>
      </FormContainer>
      <InfoContainer>
        <MediumText lineHeight="1.3">{t('ONBOARD_TEXT.selectTypeOfServiceTitle')}</MediumText>
        <DefaultText color={dealTokens.color.textMuted} marginTop={2}>
          {t('ONBOARD_TEXT.selectTypeOfServiceSubtitle')}
        </DefaultText>

        <div style={{ marginTop: dealTokens.space[6], paddingTop: dealTokens.space[5], borderTop: `1px solid ${dealTokens.color.border}` }}>
          <div
            style={{
              fontSize: 11,
              fontWeight: dealTokens.font.weightSemibold,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              color: dealTokens.color.textMuted,
              marginBottom: dealTokens.space[4],
            }}
          >
            {t('ONBOARD_TEXT.selectTypeOfServiceCheckboxTitle')}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: dealTokens.space[4] }}>
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.selectTypeOfServiceCheckbox1Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.selectTypeOfServiceCheckbox2Text')} />
            <CheckboxInfoContainer text={t('ONBOARD_TEXT.selectTypeOfServiceCheckbox3Text')} />
          </div>
        </div>

        <PlayGuideVideoEmbed videoId={guideVideos.selectTypeOfService.videoId} modalTitle={guideVideos.selectTypeOfService.title} />
      </InfoContainer>
    </MainContainer>
  );
};

export default SelectService;
